import types from "./actionTypes";
import { dealWithMessages } from '../../undoredo/actions'

export const addMessage = (payload, noUndoRedo) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithMessages(payload, 'add'))

	dispatch({
		type: types.ADD_MESSAGE,
		payload,
	})
};

export const editMessage = (payload, noUndoRedo) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithMessages(payload, 'edit'))

	dispatch({
		type: types.EDIT_MESSAGE,
		payload,
	})
};

export const deleteMessage = (payload) => ({
	type: types.DELETE_MESSAGE,
	payload,
})

export const updateFullMessages = (messages) => ({
	type: types.UPDATE_FULL_MESSAGES,
	payload: messages
})

export const resetMessages = (messages) => ({
	type: types.RESET_MESSAGES,
	payload: messages
})
